<div class="container" [ngClass]="{ 'row-2': rows === 2,'autoHeight':autoHeight}">
    <div class="header d-flex align-items-center">
        <div class="logo-icon"></div>
        <h3 class="d-inline">
            <span *ngIf="!blockTitleAsLink">{{ title }}</span>
            <a routerLink="{{ link }}" *ngIf="blockTitleAsLink && !linkParams">{{ title }}</a>
            <a [routerLink]="[link]" [queryParams]="linkParams" *ngIf="blockTitleAsLink && linkParams">{{ title }}</a>
        </h3>
        <div *ngIf="!!category?.subcate" class="d-flex align-items-center ml-4">
            <a [routerLink]="[subcate.routerLink]" [queryParams]="subcate.params"
                class="sub-category" *ngFor="let subcate of category.subcate">
                <span>{{ subcate.title }}</span>
            </a>
        </div>
        <a [routerLink]="[link]" *ngIf="showHistoryButton" class="mainColor d-flex align-items-center ml-4">
            <span>更多</span>
            <span class="iconfont iconjiantou_liebiaoxiangyou fs-16"></span>
        </a>
    </div>
    <div class="content" *ngIf="!showHistoryButton">
        <!--part 1-->
        <div class="d-flex align-items-start mb-4 v-place" [ngClass]="{'no-bg':recommendedVideos.length>0}">
            <div class="v-c video-item new" *ngFor="let recommendedVideo of firstPart; let last=last; let i=index"
                [ngClass]="{'visible-lg':i==6 && rows ==1,'visible-xl':i>=6&&rows ==1,'hidden-lg':rows==2&& i == 5}"
                [video]="recommendedVideo" [display]="display">
                <div class="teaserDetail" [hovered]="true"
                    [video]="recommendedVideo">
                </div>
            </div>
        </div>

        <div class="d-flex align-items-start mb-4 v-place" *ngIf="(actionList.indexOf(slug) > -1) "
            [ngClass]="{'no-bg':recommendedVideos.length>0}">
            <div class="v-c video-item mb-2 new" *ngFor="let recommendedVideo of secondPart;let last=last; let i=index"
                [ngClass]="{'hidden-lg':rows==2&& i == 5}"
                [video]="recommendedVideo" >
                <div class="teaserDetail"  [hovered]="true"
                    [video]="recommendedVideo">
                </div>
               
            </div>
        </div>


        <app-top-ranked-videos *ngIf="responseList.indexOf(slug) > -1" [title]="title" [cid]="category.cid"
            [moreLink]="category.ranklink" class="visible-lg visible-xl">
        </app-top-ranked-videos>

    </div>

    <div class="content" *ngIf="showHistoryButton">
        <div class="rec-slider-hasWatched position-relative d-flex align-items-start mb-2 v-n-place new"
            [ngClass]="{'no-bg': recommendedVideos.length > 0}">
            <div class="nav-shadow-cover last" *ngIf="currentIndex > 0 "
              [style.height.px]="hasWatchedSize.height" [style.width.px]="hasWatchedSize.width">
            </div>
            <div class="nav-btn last" *ngIf="currentIndex > 0" [style.height.px]="hasWatchedSize.height">
              <i class="iconfont iconjiantou_liebiaoxiangzuo" (click)="navLast()"></i>
            </div>
            <div class="rec-track d-flex" #track>
                <div class="v-c hasWatched video-item new" *ngFor="let recommendedVideo of recommendedVideos; let i=index"
                    [video]="recommendedVideo" [display]="display" [hasWatched]="showHistoryButton"
                 >
                    <!-- 正在追去掉简介 -->
                    <!-- <div class="teaserDetail" [hovered]="true"
                        [video]="recommendedVideo"
                        [hasWatched]="showHistoryButton"
                        [newStyle]="newStyle">
                    </div>
                    <div class="teaser-cover" *ngIf="!newStyle">
                        <div class="cover-play-area">
                            <a [routerLink]="['/play',recommendedVideo.key]" class="cover-play-button"
                                title="{{recommendedVideo.title}}">
                                <i class="iconfont iconbofang play-icon"></i>
                            </a>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="nav-shadow-cover next" *ngIf="currentIndex < (recommendedVideos.length - newColumn) "
              [style.height.px]="hasWatchedSize.height" [style.width.px]="hasWatchedSize.width">
            </div>
            <div class="nav-btn next" *ngIf="currentIndex < (recommendedVideos.length - newColumn)" [style.height.px]="hasWatchedSize.height">
              <i class="iconfont iconjiantou_liebiaoxiangyou" (click)="navNext()"></i>
            </div>
          </div>
    </div>
</div>